import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClientHealthDashboard = ({ client, onClose }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-foreground">Client Health Dashboard</h2>
        <Button variant="ghost" size="sm" onClick={onClose}>
          <Icon name="X" size={16} />
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* User Engagement */}
        <div className="bg-primary/5 rounded-lg p-4 border border-primary/20">
          <div className="flex items-center justify-between mb-3">
            <Icon name="Users" size={20} className="text-primary" />
            <span className="text-2xl font-bold text-foreground">85%</span>
          </div>
          <h3 className="text-sm font-medium text-foreground mb-1">User Engagement</h3>
          <p className="text-xs text-muted-foreground">Active user rate</p>
        </div>

        {/* Feature Adoption */}
        <div className="bg-success/5 rounded-lg p-4 border border-success/20">
          <div className="flex items-center justify-between mb-3">
            <Icon name="TrendingUp" size={20} className="text-success" />
            <span className="text-2xl font-bold text-foreground">72%</span>
          </div>
          <h3 className="text-sm font-medium text-foreground mb-1">Feature Adoption</h3>
          <p className="text-xs text-muted-foreground">Features utilized</p>
        </div>

        {/* Support Requests */}
        <div className="bg-warning/5 rounded-lg p-4 border border-warning/20">
          <div className="flex items-center justify-between mb-3">
            <Icon name="MessageSquare" size={20} className="text-warning" />
            <span className="text-2xl font-bold text-foreground">3</span>
          </div>
          <h3 className="text-sm font-medium text-foreground mb-1">Support Requests</h3>
          <p className="text-xs text-muted-foreground">Last 30 days</p>
        </div>
      </div>

      <div className="mt-6">
        <h3 className="text-sm font-medium text-foreground mb-3">Recent Activity</h3>
        <div className="space-y-2">
          <div className="flex items-center justify-between py-2 border-b border-border">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle" size={16} className="text-success" />
              <span className="text-sm text-foreground">Payroll processed successfully</span>
            </div>
            <span className="text-xs text-muted-foreground">2 hours ago</span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-border">
            <div className="flex items-center gap-2">
              <Icon name="UserPlus" size={16} className="text-primary" />
              <span className="text-sm text-foreground">5 new employees added</span>
            </div>
            <span className="text-xs text-muted-foreground">1 day ago</span>
          </div>
          <div className="flex items-center justify-between py-2">
            <div className="flex items-center gap-2">
              <Icon name="FileText" size={16} className="text-muted-foreground" />
              <span className="text-sm text-foreground">Compliance report generated</span>
            </div>
            <span className="text-xs text-muted-foreground">3 days ago</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientHealthDashboard;